import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { ThemeProvider } from '@/contexts/ThemeContext'
import Chat from '@/pages/Chat'
import Login from '@/pages/LoginSSO'
import Callback from '@/pages/Callback'
import { ChatProvider } from './hooks/useChat'

function Layout({ children }: { children: React.ReactNode }) {
    const location = useLocation()
    return (
        <div className="h-screen flex pt-[69px]">
            <div className="flex-1 flex flex-col overflow-hidden">
                <main className={`flex-1 overflow-auto ${location.pathname === '/' ? 'p-0' : 'p-6'}`}>
                    {children}
                </main>
            </div>
        </div>
    )
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const auth = useAuth()
    if (!auth.isAuthenticated) {
        return <Navigate to="/login" replace />
    }
    return <Layout>{children}</Layout>
}

export default function App() {
    return (
        <ThemeProvider>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/callback" element={<Callback />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <ChatProvider>
                                <Chat />
                            </ChatProvider>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </ThemeProvider>
    )
}